import styled from 'styled-components';

export const DataEntry = styled.div`
  flex: 1 1 auto;
  display: grid;
  grid-gap: 5px;
  padding-bottom: 15px;
  grid-template-columns: min-content minmax(min-content, 1fr);

  .label {
    min-width: 125px;
    font-weight: bold;
  }

  span.no-break {
    white-space: nowrap;
    margin-left: 0.5rem;
    color: #353535;
    font-size: 0.875em;
  }

  &.questionnaireRow {
    grid-template-columns: minmax(min-content, 3fr) max-content;
    row-gap: 1rem;
  }

  & .questions-divider {
    grid-column: 1 / span 2;
    height: 1.5rem;

    &.small {
      height: 0.75rem;
    }
  }

  & .question-num-label {
    font-weight: normal;
    color: #575757;
  }

  & .question-container {
    display: flex;
    min-width: 22rem;
    max-width: 22rem;
    grid-column: 2 / span 1;

    .button-back,
    .button-next {
      flex: 0 0 auto;
      align-self: flex-start;
    }

    .button-back {
      margin-left: -2.5rem;
    }

    .button-next {
      margin-right: -2.3rem;
    }

    .question {
      flex: 1 1 auto;
      margin: 0.175rem 0.45rem 0.175rem 0.2rem;

      .question-wrapper.inactive {
        display: none;
      }

      .question-text {
        font-weight: normal;
        margin-bottom: 1.2rem;
        min-height: 2rem;
      }
    }
  }
`
export const Label = styled.div`
    min-width: 125px;
`;

export const DataEntryValue = styled.div`
  min-width: 23rem;

  .date-time-value & {
    min-width: 5rem;
  }

  .referral-doctor-value & {

    & .doctor-email-container {
      min-width: 23rem;
      color: #8a7305;
      display: flex;
      flex-direction: row-reverse;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: .2rem;

      & .ui.button {
        margin: unset;
      }
    }
  }

  &.answer-value {
    min-width: 170px;
  }

  & .availability-details {
    margin-top: .5rem;
    font-weight: 600;
  }
`
